import styled from 'styled-components';
import BaseModal from 'components/molecules/Modal/BaseModal';
import GroupNameEditModal from 'components/molecules/Modal/GroupNameEditModal';
import ConfirmationModal from 'components/molecules/Modal/ConfirmationModal';
import ResponsiveModal from 'components/molecules/Modal/ResponsiveModal';

const Modal = styled(BaseModal).attrs({
    zIndex: 1200,
})`
    & .ant-modal-body {
        width: 100%;
        padding: 30px;
    }

    & .ant-modal-header {
        border: 0px;
    }

    & .ant-modal-footer {
        border: 0px;
        padding-left: 24px;
        padding-right: 24px;
        padding-top: 5px;
    }

    & .ant-select-selection {
        box-shadow: 0;
    }

    & .ant-modal-content {
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    & .ant-modal-close {
        height: 60px;
        width: 60px;
    }
`;

export { Modal, GroupNameEditModal, ConfirmationModal, ResponsiveModal };
export default Modal;
